<rid-categorise-yes-no
  class="h-dvh"
  [questions]="[
    {
      id: 'q1',
      question: 'Zit er een fopletter in dit woord?',
      options: [
        {
          type: 'AUDIO',
          src: 'https://api.woordkr8.dev.gametailors.com/cas/schemas/woordkr8/data/woordkr8-dev/media/fetch/JEOE5HvotZVLUtbnIaXb0.mp3',
        },
      ],
      answer: 'YES',
    },
  ]"
  (finished)="$router.navigate(['/mechanics/sorting/yes-or-no'])"
/>
